module.exports = __webpack_public_path__ + "img/nodata.a334ac7f.svg";